import { useCallback } from 'react';
import type { FormProps } from 'react-final-form';
import { get } from 'lodash';

import { users } from 'api';
import { wrapWithStore } from 'helpers/store';
import { showErrorToast } from 'helpers/toasts';
import { goToUrl } from 'helpers/utils';
import routes from 'routes';
import useModalState from 'components/ModalHandler/useModalState';

import type { Values } from './types';

export interface RenderProps {
  onGoToHomePage: () => void;
  onSubmit: FormProps<Values>['onSubmit'];
  onCloseModal: () => void;
  isSuccessModalOpen: boolean;
}

function ForgotPassowordPageContainer({ render }: ContainerProps<RenderProps>) {
  const [isModalOpen, openModal, closeModal] = useModalState();

  const onSubmit = useCallback<RenderProps['onSubmit']>(
    async ({ email }) => {
      try {
        await users().password().POST({ email });

        openModal();
      } catch (error) {
        const errors = get(error, 'response.data.errors');
        showErrorToast(errors, { isTranslated: true });
      }
    },
    [openModal]
  );

  return render({
    onSubmit,
    onCloseModal: closeModal,
    isSuccessModalOpen: isModalOpen,
    onGoToHomePage: () => goToUrl(routes.root.path()),
  });
}

export default wrapWithStore(ForgotPassowordPageContainer);
